import { createContext } from "react";

const fulfillmentContext = createContext();

export default fulfillmentContext;
